import type { CityConfig } from "../city-template/types";

export const danvilleVaConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  vitalRecordsLinks: [
    { label: "Birth & Death Certificates — Virginia Dept of Health Vital Records", href: "https://www.vdh.virginia.gov/vital-records/", description: "Official Virginia vital records office in Richmond" },
    { label: "Marriage Licenses — Danville Circuit Court Clerk", href: "https://www.danville-va.gov/", description: "Danville Circuit Court Clerk — marriage license issuance" },
    { label: "Divorce Records — Danville Circuit Court Clerk", href: "https://www.danville-va.gov/", description: "Danville Circuit Court Clerk — divorce decree records" },
    { label: "VitalChek — Order Vital Records Online", href: "https://www.vitalchek.com/", description: "Official partner of VDH for online vital record orders" },
  ],
  city: "Danville",
  state: "Virginia",
  stateAbbr: "VA",
  slug: "danville-va",
  route: "/danville-va",
  title: "Emergency Passport Danville, VA — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Danville, VA — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Danville, Pittsylvania County, and Southside Virginia. Get your passport fast!",
  h1: "Emergency & Expedited Passport Services in Danville, VA",
  heroSubtitle: "Passport expired before your trip? Traveling from Pittsylvania County, Southside Virginia, or the Dan River Region? We help Danville travelers get expedited passports as quickly as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Danville%20Virginia%20downtown%20with%20historic%20River%20District%20along%20the%20Dan%20River%2C%20the%20renovated%20tobacco%20warehouses%20and%20historic%20mill%20buildings%20on%20the%20Riverwalk%20Trail%2C%20modern%20revitalized%20downtown%20with%20brick%20architecture%20and%20the%20historic%20crossing%20at%20the%20Dan%20River%2C%20warm%20afternoon%20light%20with%20rolling%20Southside%20Virginia%20hills%20and%20the%20Piedmont%20landscape%2C%20professional%20photography%20showcasing%20Southwest%20Virginia%20riverfront%20city%20with%20historic%20industrial%20charm%20and%20modern%20revitalization%2C%20no%20people%20visible%2C%20scenic%20urban%20landscape%20with%20riverfront%20and%20rolling%20hills&width=1800&height=700&seq=danville-va-hero-001&orientation=landscape",
  heroImageAlt: "Danville Virginia historic River District along the Dan River with renovated tobacco warehouses and riverfront trail",
  geoPosition: "36.5860;-79.3950",
  geoPlacename: "Danville, Virginia",
  regionalAgency: {
    name: "Washington Passport Agency",
    address: "600 19th Street NW, Washington, DC 20006",
    distance: "Located in downtown Washington, DC — approximately 220 miles north of Danville via US-29 and I-66",
  },
  nearbyCitiesZips: [
    { name: "Danville", zips: "24540, 24541, 24543, 24544" },
    { name: "Pittsylvania County", zips: "24540, 24541, 24543, 24544, 24531, 24549, 24551, 24557, 24563, 24565, 24569, 24571, 24577, 24586, 24592, 24598" },
    { name: "South Boston", zips: "24592" },
    { name: "Chatham", zips: "24531" },
    { name: "Gretna", zips: "24557" },
    { name: "Hurt", zips: "24563" },
    { name: "Ringgold", zips: "24586" },
    { name: "Blairs", zips: "24527" },
    { name: "Roxboro NC", zips: "27573" },
    { name: "Martinsville", zips: "24112, 24113, 24114, 24115" },
    { name: "Greensboro NC", zips: "27401, 27402, 27403, 27404, 27405, 27406, 27407, 27408, 27409, 27410, 27411, 27412, 27413, 27415, 27416, 27417, 27419, 27420, 27425, 27427, 27429, 27435, 27438, 27455, 27495, 27497, 27498, 27499" },
    { name: "Lynchburg", zips: "24501, 24502, 24503, 24504, 24505, 24506, 24514, 24515" },
    { name: "Roanoke", zips: "24001, 24002, 24003, 24004, 24005, 24006, 24007, 24008, 24009, 24010, 24011, 24012, 24013, 24014, 24015, 24016, 24017, 24018, 24019, 24020, 24022, 24023, 24024, 24025, 24026, 24027, 24028, 24029, 24030, 24031, 24032, 24033, 24034, 24035, 24036, 24037, 24038, 24040, 24042, 24043, 24044, 24045, 24048, 24050, 24054, 24055, 24059, 24060, 24061, 24062, 24063, 24064, 24065, 24066, 24067, 24068, 24070, 24072, 24073, 24077, 24078, 24079, 24083, 24084, 24085, 24086, 24087, 24088, 24089, 24090, 24091, 24092, 24095" },
    { name: "Richmond", zips: "23218, 23219, 23220, 23221, 23222, 23223, 23224, 23225, 23226, 23227, 23228, 23229, 23230, 23231, 23233, 23234, 23235, 23236, 23237, 23238, 23242" },
    { name: "Charlottesville", zips: "22901, 22902, 22903, 22911, 22936, 22947, 22972, 22974" },
    { name: "Greensboro", zips: "27401, 27402, 27403, 27404, 27405, 27406, 27407, 27408, 27409, 27410, 27411, 27412, 27413, 27415, 27416, 27417, 27419, 27420, 27425, 27427, 27429, 27435, 27438, 27455, 27495, 27497, 27498, 27499" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent travel departures from Southside Virginia and the Dan River Region" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-map-pin-2-line", title: "Southside Virginia Hub", desc: "Serving Danville, Pittsylvania County, South Boston, Martinsville, and the Dan River Region" },
  ],
  internalLinks: [
    { name: "Virginia state passport services", route: "/states/virginia" },
    { name: "Lynchburg VA passport services", route: "/lynchburg-va" },
    { name: "Roanoke VA passport services", route: "/roanoke-va" },
    { name: "Richmond VA passport services", route: "/richmond-va" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Danville remotely via secure courier. We do not have a walk-in office in Danville — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Danville and Southside Virginia travelers.",
  fpcOfficeAddress: "1629 K St NW #300, Washington, DC 20006",
  fpcOfficeDistance: "Serving all of Danville and Southside Virginia including Pittsylvania County, South Boston, Chatham, Gretna, Hurt, Ringgold, and the greater Dan River Region",
  serviceAreaIntro: "From the historic River District and renovated tobacco warehouses along the Dan River to the rolling hills of Pittsylvania County, from the vibrant revitalization of downtown Danville to the quiet communities of South Boston, Chatham, and Gretna, from the Piedmont farmlands to the southern Virginia border — Fast Passport Center serves every corner of Danville and Southside Virginia. We regularly help travelers from Martinsville, South Boston, and the greater Dan River Region get their passports fast.",
  nearbyCitiesIntro: "We serve all Danville neighborhoods and Southside Virginia including Pittsylvania County, South Boston, Chatham, Gretna, Hurt, Ringgold, Martinsville, and the surrounding Dan River Region.",
  howItWorksIntro: "Most Danville travelers complete everything online and ship documents overnight. No need to drive to the Washington regional agency or wait in long government lines.",
  mistakesIntro: "Danville travelers often face the temptation to drive to the Washington regional passport agency. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Danville and Southside Virginia travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Danville? Here are the most common ones we hear from Southside Virginia travelers.",
  statePageRoute: "/states/virginia",
  statePageName: "Virginia",
  dmvWebsite: "https://www.dmv.virginia.gov",
  dmvLabel: "Virginia DMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For travelers with immediate departure needs — as fast as 24 hours for urgent Danville international flights and last-minute travel.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "Tamara J.",
      location: "Danville, VA",
      rating: 5,
      text: "I needed an emergency passport for a family emergency overseas with only 4 days notice. Fast Passport Center had my renewal in 3 days. I shipped from the UPS in downtown Danville and it was completely seamless. No need to drive to DC or wait in government lines.",
      service: "Emergency Passport",
    },
    {
      name: "Robert W.",
      location: "South Boston, VA",
      rating: 5,
      text: "As a South Boston resident, I was worried about finding expedited passport services close to home. Fast Passport Center made it incredibly easy. Everything was done online, and my renewal was back in 5 days. The convenience for Southside Virginia families is unbeatable.",
      service: "Passport Renewal",
    },
    {
      name: "Karen M.",
      location: "Chatham, VA",
      rating: 5,
      text: "First passports for my three kids before a family cruise to the Caribbean. Fast Passport Center handled all the parental consent requirements perfectly and had all three passports in 6 days. For Pittsylvania County families, this is the best expedited passport service available.",
      service: "Child Passport",
    },
    {
      name: "Eric D.",
      location: "Danville, VA",
      rating: 5,
      text: "Lost my passport 2 days before a business trip to Mexico. I was in absolute panic. Fast Passport Center had a replacement in my hands in 48 hours. They saved my business trip and my client relationship. Danville professionals need this service.",
      service: "Lost Passport",
    },
  ],
  facilities: [
    {
      id: "danville-va-1",
      name: "Danville Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "Street address pending USPS listing",
      city: "Danville",
      state: "VA",
      zip: "24540",
      phone: "(434) 792-6511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Danville",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Danville facility. Full passport services with appointment. Call ahead to confirm.",
      icon: "ri-mail-line",
    },
    {
      id: "danville-va-2",
      name: "South Boston Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "Street address pending USPS listing",
      city: "South Boston",
      state: "VA",
      zip: "24592",
      phone: "(434) 572-2841",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "South Boston, east of Danville",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves eastern Pittsylvania County. Full passport services with appointment.",
      icon: "ri-mail-line",
    },
    {
      id: "danville-va-3",
      name: "Chatham Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "Street address pending USPS listing",
      city: "Chatham",
      state: "VA",
      zip: "24531",
      phone: "(434) 432-7931",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Chatham, northwest of Danville",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves northern Pittsylvania County. Full passport services with appointment.",
      icon: "ri-mail-line",
    },
    {
      id: "danville-va-4",
      name: "Martinsville Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "Street address pending USPS listing",
      city: "Martinsville",
      state: "VA",
      zip: "24112",
      phone: "(276) 632-2151",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Martinsville, west of Danville",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Martinsville and Henry County. Full passport services with appointment.",
      icon: "ri-mail-line",
    },
    {
      id: "danville-va-5",
      name: "Pittsylvania County Clerk",
      type: "County Clerk",
      address: "1 Main St",
      city: "Chatham",
      state: "VA",
      zip: "24531",
      phone: "(434) 432-7750",
      hours: "Mon–Fri: 8:30 AM – 4:30 PM",
      distance: "Chatham, Pittsylvania County",
      website: "https://www.pittsylvaniacountyva.gov",
      websiteLabel: "Pittsylvania County Clerk",
      notes: "Provides vital records and birth certificates. Not a passport acceptance facility but useful for document collection.",
      icon: "ri-building-2-line",
    },
    {
      id: "danville-va-6",
      name: "Danville Register & Bee",
      type: "Local Resource",
      address: "700 Monument St",
      city: "Danville",
      state: "VA",
      zip: "24543",
      phone: "(434) 791-1400",
      hours: "Mon–Fri: 8:00 AM – 5:00 PM",
      distance: "Downtown Danville",
      website: "https://www.danville.com",
      websiteLabel: "Danville Register & Bee",
      notes: "Not a passport acceptance facility, but helpful for local announcements and community resources.",
      icon: "ri-building-2-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 4+ hour drive to DC", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
    { feature: "Who Can Use It", agency: "Life-or-death emergencies only — proof required", fpc: "All travelers — urgent, expedited, or planned" },
    { feature: "Cost vs Resellers", agency: "Government fee only — no courier service", fpc: "30–100% less than FedEx, Staples, and other resellers" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Danville photo shops often use generic sizes. Passport photos must be exactly 2x2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Southside Virginia acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Danville applicants show up with incorrect payment and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the Washington DC regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Danville families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Danville travelers often assume standard processing will be fine. It takes 8-11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Danville or nearby." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Danville address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Danville before my international trip?", a: "Yes. Fast Passport Center provides emergency passport services in Danville for travelers with urgent international departures. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24-48 hour turnaround — perfect for last-minute trips from Southside Virginia and the Dan River Region." },
    { q: "How fast can I renew my passport in Danville?", a: "Fast Passport Center offers fast passport renewal in Danville in as little as 24-48 hours through our emergency courier service. For less urgent travel, our 3-5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What is the closest passport agency to Danville?", a: "The nearest regional passport agency to Danville is the Washington Passport Agency, located approximately 220 miles north in downtown Washington, DC. For urgent processing without the long drive, Fast Passport Center's registered courier service achieves 24-48 hour turnaround from Danville." },
    { q: "Can I get a same-day passport appointment near Danville?", a: "Same-day passport appointments are only available at the Washington Regional Passport Agency for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24-48 hour emergency courier processing is the fastest guaranteed option for Danville residents." },
    { q: "Can I expedite a child passport in Danville?", a: "Yes. Fast Passport Center expedites child passports in Danville for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk Danville and Southside Virginia families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Danville with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24-48 hours." },
    { q: "How fast can I get a passport in Danville?", a: "With Fast Passport Center's emergency courier service, Danville travelers can receive their passport in as little as 24-48 hours. Our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities, bypassing standard mail delays." },
    { q: "Do I need to drive to the Washington Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
    { q: "Where are the closest passport acceptance facilities near Danville?", a: "Popular options include the Danville Post Office (24540), South Boston Post Office (24592), Chatham Post Office (24531), and Martinsville Post Office (24112). All require appointments. We help you find the most convenient location and schedule your visit." },
    { q: "What if I live in South Boston, Chatham, or Martinsville?", a: "We serve all of Southside Virginia including South Boston, Chatham, Martinsville, Gretna, Hurt, Ringgold, and Pittsylvania County. Our overnight shipping labels work from any UPS location, so your location doesn't affect processing speed." },
    { q: "How much does expedited passport service cost in Danville?", a: "Government fees are fixed: $130 for a passport book (adult) plus a $60 expedite fee. Fast Passport Center's service fees vary by processing speed — emergency 24-48 hour processing, 3-5 day expedited, or standard options. Contact us for a personalized quote." },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Danville", address: "1030 S Boston Rd, Danville, VA 24540", hours: "Mon-Sun: 8AM-10PM", website: "https://www.cvs.com/photo" },
    { name: "Walgreens — Danville", address: "2005 Riverside Dr, Danville, VA 24540", hours: "Mon-Sun: 7AM-11PM", website: "https://www.walgreens.com/photo" },
    { name: "Walmart — Danville", address: "515 Mount Cross Rd, Danville, VA 24540", hours: "Mon-Sun: 7AM-10PM", website: "https://www.walmart.com/cp/photo/1078904" },
    { name: "CVS Pharmacy — South Boston", address: "1120 E Atlantic St, South Boston, VA 24592", hours: "Mon-Sun: 8AM-10PM", website: "https://www.cvs.com/photo" },
    { name: "Walgreens — Martinsville", address: "800 E Church St, Martinsville, VA 24112", hours: "Mon-Sun: 7AM-11PM", website: "https://www.walgreens.com/photo" },
    { name: "FedEx Office — Danville", address: "1040 Piney Forest Rd, Danville, VA 24540", hours: "Mon-Fri: 7AM-9PM, Sat: 8AM-6PM", website: "https://www.office.fedex.com/default/office" },
  ],
  dmvLocations: [
    {
      name: "Virginia DMV — Danville",
      address: "1050 S Main St, Danville, VA 24541",
      hours: "Mon-Fri: 8AM-5PM",
      note: "Driver's license and REAL ID services. Appointment recommended.",
      featured: true,
    },
    {
      name: "Virginia DMV — South Boston",
      address: "2000 E Atlantic St, South Boston, VA 24592",
      hours: "Mon-Fri: 8AM-5PM",
      note: "REAL ID and passport-related ID services. Appointment strongly recommended.",
      featured: false,
    },
    {
      name: "Virginia DMV — Martinsville",
      address: "800 E Church St, Martinsville, VA 24112",
      hours: "Mon-Fri: 8AM-5PM",
      note: "Serves Martinsville and Henry County. REAL ID available.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "ROA",
      name: "Roanoke-Blacksburg Regional Airport",
      distance: "Approximately 85 miles north of Danville via US-29",
      address: "5202 Aviation Dr NW, Roanoke, VA 24012",
      note: "Regional hub for western Virginia. Accessible via US-29.",
      flightUrl: "https://www.flyroa.com/",
      flightLabel: "ROA Airport",
      featured: false,
    },
    {
      code: "LYH",
      name: "Lynchburg Regional Airport",
      distance: "Approximately 70 miles north of Danville via US-29",
      address: "350 Terminal Dr, Lynchburg, VA 24502",
      note: "Regional hub for Central Virginia. Accessible via US-29.",
      flightUrl: "https://www.flylyh.com/",
      flightLabel: "LYH Airport",
      featured: true,
    },
    {
      code: "RIC",
      name: "Richmond International Airport",
      distance: "Approximately 120 miles northeast of Danville via US-360",
      address: "1 Richard E. Byrd Terminal Dr, Richmond, VA 23250",
      note: "Regional hub for Central Virginia. Accessible via US-360.",
      flightUrl: "https://www.flyrichmond.com/",
      flightLabel: "RIC Airport",
      featured: false,
    },
    {
      code: "GSO",
      name: "Piedmont Triad International Airport",
      distance: "Approximately 60 miles south of Danville via US-29",
      address: "1000A Ted Johnson Pkwy, Greensboro, NC 27409",
      note: "Regional hub for the Piedmont Triad. Just across the NC border.",
      flightUrl: "https://www.flyfrompti.com/",
      flightLabel: "GSO Airport",
      featured: false,
    },
  ],
};